// Number formats for the dashboard, in British English
const whole = new Intl.NumberFormat("en-GB");
const compact = new Intl.NumberFormat("en-GB", {
  notation: "compact",
  maximumFractionDigits: 1,
});

// 1,284 up to 10,000, then 12.9K
export const count = (value) =>
  Math.abs(value) >= 10000 ? compact.format(value) : whole.format(value);

export const decimal = (value, digits = 1) =>
  new Intl.NumberFormat("en-GB", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);

export const percent = (value) => `${Math.round(value)}%`;

// OpenAI bills in US dollars
export const dollars = (value) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);

export const cents = (dollarValue) => `${decimal(dollarValue * 100, 2)}¢`;

export const money = (amount, currency) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: currency.toUpperCase(),
  }).format(amount);

// The API leaves out days with nothing recorded; this fills them with 0 so the
// chart doesn't join across gaps. Returns the last `days` days, oldest first.
export const everyDay = (points, days = 30) => {
  const byDay = new Map(points.map((point) => [point.x, point.y]));
  const today = new Date();
  return Array.from({ length: days }, (_, index) => {
    const date = new Date(today);
    date.setUTCDate(today.getUTCDate() - (days - 1 - index));
    const key = date.toISOString().slice(0, 10);
    return { x: key, y: byDay.get(key) ?? 0 };
  });
};

// This week against the week before, from a filled daily series
export const weekChange = (series) => {
  const sum = (list) => list.reduce((total, point) => total + point.y, 0);
  const thisWeek = sum(series.slice(-7));
  const lastWeek = sum(series.slice(-14, -7));
  const change = lastWeek ? ((thisWeek - lastWeek) / lastWeek) * 100 : null;
  return { thisWeek, lastWeek, change };
};

export const shortDate = (key) =>
  new Date(`${key}T00:00:00Z`).toLocaleDateString("en-GB", {
    weekday: "short",
    day: "numeric",
    month: "short",
    timeZone: "UTC",
  });
